/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPoll,
    JsonPollFromJSON,
    JsonPollFromJSONTyped,
    JsonPollToJSON,
} from './JsonPoll';

/**
 * 
 * @export
 * @interface ApiResultOfJsonPoll
 */
export interface ApiResultOfJsonPoll {
    /**
     * 
     * @type {JsonPoll}
     * @memberof ApiResultOfJsonPoll
     */
    data?: JsonPoll;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPoll
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonPoll
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPoll
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPoll
     */
    result?: ApiResultOfJsonPollResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonPollResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonPollFromJSON(json: any): ApiResultOfJsonPoll {
    return ApiResultOfJsonPollFromJSONTyped(json, false);
}

export function ApiResultOfJsonPollFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonPoll {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonPollFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonPollToJSON(value?: ApiResultOfJsonPoll | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonPollToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

